import React, {useEffect, useState} from "react";
import "./CollaborationRequestPage.sass";
import Window from "../../../../_containers/window/Window";
import TextFieldEdit from "../../../../_components/common/fields/TextFieldEdit";
import PhoneNumberTextEdit from "../../../../_components/common/fields/PhoneNumberTextEdit";
import CircleButton from "../../../../_components/common/buttons/CircleButton";
import CloseIcon from "@mui/icons-material/Close";
import ButtonComponent from "../../../../_components/common/buttons/ButtonComponent";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router";
import {saveCollaborationRequest, setEmpty} from "../../../../_actions/commonService";
import {LOADING, SUCCESS} from "../../../../common/statuses";
import Spinner from "../Spinner";
import {COLLABORATION_PAGE} from "../../../../common/links";


export const CollaborationRequestPage = () => {

    const [email, setEmail] = useState("");
    const [fio, setFio] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isSuccess, setSuccess] = useState(false)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {status, errors} = useSelector(state => state.common.request);

    useEffect(() => {
        document.title = 'КьюАй - Стать преподавателем'
        return () => {
            dispatch(setEmpty())
        }
    }, []);

    if (status === LOADING) {
        return <Spinner/>
    }

    const handleSave = () => {
        const request = {
            email,
            fullName: fio,
            phoneNumber
        }
        dispatch(saveCollaborationRequest(request))
    }

    return <Window>
        <div className="CollaborationRequestPage-title">
            <div className="CollaborationRequestPage-title-text">
                {status === SUCCESS ? "Ваша заявка принята" : "Заявка на сотрудничество"}
            </div>
            <div><CircleButton Icon={CloseIcon} onClick={() => navigate(COLLABORATION_PAGE)}/></div>
        </div>
        {
            status === SUCCESS
                ? <>
                    <div className="CollaborationRequestPage-main CollaborationRequestPage-main-success">
                        Ваша заявка принята, с вами свяжутся в ближайшее время
                    </div>
                </>
                : <>
                    <div className="CollaborationRequestPage-main">
                        <TextFieldEdit label="Электронная почта*"
                                       error={errors && errors['email']}
                                       helperText={errors && errors['email']}
                                       value={email}
                                       onChange={(e) => setEmail(e.target.value)}
                        />
                        <TextFieldEdit label="Ваш ФИО*"
                                       error={errors && errors['fullName']}
                                       helperText={errors && errors['fullName']}
                                       value={fio}
                                       onChange={(e) => setFio(e.target.value)}
                        />
                        <PhoneNumberTextEdit label="Номер телефона*"
                                             error={errors && errors['phoneNumber']}
                                             helperText={errors && errors['phoneNumber']}
                                             value={phoneNumber}
                                             onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                    </div>
                    <div className="CollaborationRequestPage-button">
                        <ButtonComponent onClick={handleSave}>Отправить</ButtonComponent>
                    </div>
                </>
        }

    </Window>
}